'<template>
   <div class="list_right">
      <div class="my_changePass">
         <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="密码" prop="password">
               <el-input type="password" v-model="ruleForm.password" placeholder="新密码"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="password2">
               <el-input type="password" v-model="ruleForm.password2" placeholder="重新输入密码"></el-input>
            </el-form-item>
            <el-form-item>
               <el-button type="primary" class="change_btn" @click="submitForm('ruleForm')">确认</el-button>
            </el-form-item>
         </el-form>
      </div>
   </div>
</template>


<script>
   import {
      formatDates,
      getDistanceSpecifiedTime
   } from '@/assets/js/date.js'; // 时间倒计时
   import {
      getCookie,
   } from '@/assets/js/util'; // cookie操作
   export default {
      name: 'user_changPassword_page',
      components: {},
      data() {
         var validatePass = (rule, value, callback) => {
            if (value === '') {
               callback(new Error('请输入密码'));
            } else {
               if (this.ruleForm.password2 !== '') {
                  this.$refs.ruleForm.validateField('password2');
               }
               callback();
            }
         };
         var validatePass2 = (rule, value, callback) => {
            if (value === '') {
               callback(new Error('请再次输入密码'));
            } else if (value !== this.ruleForm.password) {
               callback(new Error('两次输入密码不一致!'));
            } else {
               callback();
            }
         };
         return {
            data: null,
            ruleForm: {
               password: '',
               password2: '',
            },
            count: 60,
            timer: null,
            show: true,
            rules: {
               password: [{
                  validator: validatePass,
                  trigger: 'blur'
               }],
               password2: [{
                  validator: validatePass2,
                  trigger: 'blur'
               }],
            }
         }
      },
      mounted() {
         this.data = JSON.parse(localStorage.getItem('userInfo'));
      },
      methods: {
         submitForm(formName) {
            var _this = this;
            this.$refs[formName].validate((valid) => {
               if (valid) {
                  _this.$api.companyUpdatePassword({
                     token: getCookie('sd_token'),
                     password: _this.ruleForm.password
                  }).then(res => {
                     if (res.code == 200) {
                        _this.$message({
                           message: '修改成功！',
                           type: 'success'
                        });
                        _this.$delCookie('sd_token');
                        setTimeout(function() {
                           _this.$router.replace('/login');
                        }, 1000)
                     } else {
                        _this.$message.error(res.msg);
                     }
                  }).catch(function(error) {
                     _this.$message.error(error.msg);
                  });
               } else {
                  console.log('error submit!!');
                  return false;
               }
            });
         },
      }
   }
</script>
<style lang="less" scoped>

</style>
